module.exports = __webpack_public_path__ + "img/empty.443f70b1.svg";